var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJustificativaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H5C4.60218 3 4.22064 3.15804 3.93934 3.43934C3.65804 3.72064 3.5 4.10218 3.5 4.5V19.5C3.5 19.8978 3.65804 20.2794 3.93934 20.5607C4.22064 20.842 4.60218 21 5 21H20C20.3978 21 20.7794 20.842 21.0607 20.5607C21.342 20.2794 21.5 19.8978 21.5 19.5V4.5C21.5 4.10218 21.342 3.72064 21.0607 3.43934C20.7794 3.15804 20.3978 3 20 3ZM12.5 6C12.7225 6 12.94 6.06598 13.125 6.1896C13.31 6.31321 13.4542 6.48891 13.5394 6.69448C13.6245 6.90005 13.6468 7.12625 13.6034 7.34448C13.56 7.56271 13.4528 7.76316 13.2955 7.9205C13.1382 8.07783 12.9377 8.18498 12.7195 8.22838C12.5012 8.27179 12.275 8.24951 12.0695 8.16436C11.8639 8.07922 11.6882 7.93502 11.5646 7.75002C11.441 7.56501 11.375 7.3475 11.375 7.125C11.375 6.82663 11.4935 6.54048 11.7045 6.3295C11.9155 6.11853 12.2016 6 12.5 6ZM15.5 18.0938H9.5V16.4062H11.6562V12.0938H10.25V10.4062H13.3438V16.4062H15.5V18.0938Z",
    fill: "#2D2926"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustificativaIcon);
export default __webpack_public_path__ + "static/media/justificativa-icon.17c42064.svg";
export { ForwardRef as ReactComponent };